// LIBRARY
import React from 'react';
import { withRouter } from 'react-router-dom';

// CUSTOM
import {
	LR_PERSONAL_INFO,
	LR_OTHER_INFO,
	LR_SEL_EXAMS,
	LR_REQUEST_TYPE,
	LR_STEP_PROGRESS,
	LR_SEL_CONTENTS,
	LR_SEL_PANEL_CONTENTS,
	LR_IS_EXAM_UPDATED,
	LR_EDIT_SEL_EXAM_REF,
} from 'modules/main/lab_request/steps/constants';
import PageTitle from 'shared_components/page_title';
import Tracker from 'modules/main/lab_request/tracker';
import { requestTypes, requestLinks } from 'modules/main/settings/lab_exam_request/settings';
import SearchFormCreate from './form_for_create';
import SearchFormEdit from './form_for_edit';
import TableHeader from './table_header';
import Table from 'shared_components/search_patient_table';
import ButtonLink from './link';
import { tablePageSize } from '../settings';
import { LabRequestContext } from 'context/labRequestContext';

class SearchStep extends React.Component {
	state = {
		patients: [],
		currentPage: 1,
		pageSize: tablePageSize,
		loading: false,
		actionType: null,
	};

	static contextType = LabRequestContext;

	componentDidMount() {
		sessionStorage.removeItem(LR_PERSONAL_INFO);
		sessionStorage.removeItem(LR_OTHER_INFO);
		sessionStorage.removeItem(LR_SEL_EXAMS);
		sessionStorage.removeItem(LR_SEL_CONTENTS);
		sessionStorage.removeItem(LR_SEL_PANEL_CONTENTS);
		sessionStorage.removeItem(LR_EDIT_SEL_EXAM_REF);
		sessionStorage.removeItem('ADDRESS_CODE');
	}

	setActionType = (patientId, patientName) => {
		this.setState({ actionType: patientName ? 'byName' : 'byId' });
	};

	handleChangePage = pagination => {
		console.log('pagination =>', pagination);
		this.setState({ currentPage: pagination });
	}

	resetCurrentPage = () => {
		this.setState({ currentPage: 1 });
	}

	handleChangeSize = pageSize => {
		this.setState({ pageSize });
		// console.log('stateCurrentPage =>', this.state.currentPage);
		this.resetCurrentPage();
	};

	handleTableDoubleClick = record => {
		const { history } = this.props;
		const redirectUrl =
			sessionStorage.getItem(LR_REQUEST_TYPE) === requestTypes.create
				? requestLinks.create.step2
				: requestLinks.edit.step2;

		delete record.dateCreated;
		delete record.addressID;

		// Save personal and other info to session storage
		// for edit module
		if (record.requestHeader) {
			const { requestHeader, ...persoInfo } = record;
			const { userID, requestDateTime, ...otherInfo } = record.requestHeader;

			console.log(persoInfo);

			sessionStorage.setItem(LR_PERSONAL_INFO, JSON.stringify(persoInfo));
			sessionStorage.setItem(LR_OTHER_INFO, JSON.stringify(otherInfo));
		}

		sessionStorage.setItem(LR_IS_EXAM_UPDATED, String(0));
		sessionStorage.setItem(LR_STEP_PROGRESS, String(2));

		history.push(redirectUrl, { record });
	};

	populatePatients = patients => {
		const newPatients = patients
		.slice()
		// .sort(
		// 	(a, b) => {
		// 		// a.patientID.localeCompare(b.patientID)
		// 	const nameA = (a.patientFirstName || '').toString().toLowerCase();
        //     const nameB = (b.patientFirstName || '').toString().toLowerCase();

        //     const nameCompare = nameA.localeCompare(nameB);
        //     if (nameCompare !== 0) return nameCompare;

        //     // secondary sort by patientID ascending
        //     return (a.patientID || '').toString().localeCompare((b.patientID || '').toString());
		// })
		.map((item, index) => ({
			...item,
			key: index,
		}));

		// console.log(newPatients);

		this.setState({ patients: newPatients });
	};

	displayLoading = isLoading => {
		this.setState({ loading: isLoading });
	};

	dynamicModuleTitle = () => {
		// @ts-ignore
		let pageTitle = '';

		switch (sessionStorage.getItem(LR_REQUEST_TYPE)) {
			case requestTypes.create:
				pageTitle = 'CREATE REQUEST';
				break;
			case requestTypes.edit:
				pageTitle = 'EDIT REQUEST';
				break;
			default:
				pageTitle = 'VIEW REQUEST';
				break;
		}

		return pageTitle;
	};

	render() {
		const { patients, pageSize, loading, actionType, currentPage } = this.state;
		const reqType = sessionStorage.getItem(LR_REQUEST_TYPE);

		return (
			<div>
				<LabRequestContext.Provider value={{ resetCurrentPage: this.resetCurrentPage }}>
				<PageTitle pageTitle={this.dynamicModuleTitle()} />
				<Tracker active={0} requestType={requestTypes.create} />
				<div className="space-y-md"></div>
				<div>
					{reqType === requestTypes.create && (
						<SearchFormCreate
							populatePatients={this.populatePatients}
							displayLoading={this.displayLoading}
							storeSearchedVal={this.setActionType}
						/>
					)}
					{reqType === requestTypes.edit && (
						<SearchFormEdit
							populatePatients={this.populatePatients}
							displayLoading={this.displayLoading}
						/>
					)}
					<div className="space-y-md"></div>
					<TableHeader
						pageSize={pageSize}
						pageTotal={patients.length}
						handleChangeSize={this.handleChangeSize}
						currentPage={currentPage}
					/>
					<div className="space-y-sm"></div>

					<Table
						data={patients}
						pageSize={pageSize}
						currentPage={currentPage}
						onPaginationChange={this.handleChangePage}
						loading={loading}
						handleDoubleClick={this.handleTableDoubleClick}
						patients={patients}
						{...(actionType === 'byName' &&
							reqType === requestTypes.create && {
								footer: () => <ButtonLink />,
							})}
					/>
				</div>

				{/* { 
					(reqType === requestTypes.create && searchCount > 0) && (
						<ButtonLink dataLength={patients.length} />
					)
				} */}
				</LabRequestContext.Provider>
			</div>
		);
	}
}

export default withRouter(SearchStep);
